import React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as yup from 'yup';
import {
  Dialog,
  DialogContent,
  TextField,
  CardContent,
  DialogActions,
  Button,
  CardHeader
} from '@material-ui/core';
import { editPatientCertificationsApi } from 'api/others';


const EditPatientCertifications = ({open, onClose, certification}) => {
  const dispatch = useDispatch();

  const handleSaveCertifications = (optionValues) => {
    const option = {...certification, title: optionValues.title, values: [{...certification.values[0], title: optionValues.description}]};

    editPatientCertificationsApi({dispatch, option});
    onClose(false);
  };

  return (
    <Dialog
      fullWidth
      maxWidth={'md'}
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="edit-patient-certification"
    >
      <DialogContent>
        <Formik
          initialValues={{
            title: certification.title,
            description: certification.values[0].title
          }}
          enableReinitialize
          validationSchema={yup.object(
            {title: yup
              .string()
              .required('Certification title is required')
              .min(2, 'Must be at least 2 characters'),
            description: yup
              .string()
              .required('Description is required')
              .min(2, 'Must be at least 2 characters')}
          )}
          onSubmit={(values) => handleSaveCertifications(values)}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            <>
              <form onSubmit={handleSubmit}>
                <CardHeader
                  className="px-0"
                  subheader="Custom Option"
                />
                <CardContent className="px-0 w-full">
                  <TextField
                    className="mt-5 w-full"
                    name="title"
                    label="Certification Title"
                    value={values.title}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.title && Boolean(errors.title)}
                    helperText={touched.title && errors.title}
                  />
                  <TextField
                    className="mt-5 w-full"
                    name="description"
                    label="Description"
                    value={values.description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.description && Boolean(errors.description)}
                    helperText={touched.description && errors.description}
                  />
                </CardContent>
                <DialogActions className="m-4">
                  <Button
                    className="text-muted"
                    onClick={() => onClose(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                  >
                    Edit Patient Certification
                  </Button>
                </DialogActions>
              </form>
            </>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default EditPatientCertifications;
